module.exports = __webpack_public_path__ + "img/ms.337f3750.png";